import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class PublicListAPICall extends APICallV4 {
    _method = 'public/list';
    _type: Method = 'get';
}
